import { useMemo } from 'react';
import { rankBlueprintsForRepo } from '@runloop/reflex-contract';
import type { Blueprint } from '@/lib/types';
import { getLatestByName } from '@/lib/blueprints';

/**
 * Build-complete blueprints for the launch context, deduplicated by name
 * (keeping the most recently created) and newest first.
 *
 * A selected repo ranks the list rather than scoping it: blueprints built for
 * it lead, the rest stay selectable below. The repo's own blueprint is what
 * the caller auto-selects (see findRepoBlueprint); this hook only decides what
 * is shown, and in what order.
 */
export function useAvailableBlueprints(blueprints: Blueprint[], repoSlug?: string): Blueprint[] {
  return useMemo(() => {
    const latest = getLatestByName(blueprints.filter((bp) => bp.status === 'build_complete'));
    return repoSlug ? rankBlueprintsForRepo(latest, repoSlug) : latest;
  }, [blueprints, repoSlug]);
}
